// Comisiones de las OTAs (7-oct-2026). «Lo que te llega» en la ficha de la reserva
// (components/Reservas/PayData.vue): total − comisión de la OTA − IVA de la comisión.
// Placeholders: {channel} nombre del canal, {rate} y {vat} porcentajes ya formateados,
// {base} y {amount} importes ya formateados, {unit} tipo de habitación.
export const otaNet = {
  title: "Was bei Ihnen ankommt",
  gross: "Buchungssumme",
  grossOnChannel: "Buchungssumme bei {channel}",
  grossOfUnit: "Summe {unit}",
  commission: "Provision und Gebühren von {channel} ({rate}\u00a0%)",
  commissionOfBase: "Provision und Gebühren von {channel} ({rate}\u00a0% von {base})",
  commissionReal: "Provision {channel} (vom Kanal gemeldet)",
  vat: "MwSt. auf die Provision ({vat}\u00a0%)",
  net: "Sie erhalten (ca.)",
  howItWorks: "So wird es berechnet",
  infoEstimate: "Schätzung mit den Prozentsätzen aus „OTA-Provisionen“ der Unterkunft. Die OTA kann einen leicht abweichenden Betrag überweisen (Rundungen, Aktionen, Zahlungsgebühren).",
  infoBase: "Auf Kurtaxe und Kaution fällt keine Provision an.",
  infoReal: "{channel} hat die Provision dieser Buchung gemeldet. Die MwSt. auf die Provision ist eine Schätzung mit dem Prozentsatz aus „OTA-Provisionen“, daher bleibt der Betrag, der bei Ihnen ankommt, ein Näherungswert.",
  infoRealNoVat: "{channel} hat die Provision dieser Buchung gemeldet. Die Überweisung kann trotzdem leicht abweichen (Rundungen, Zahlungsgebühren).",
  airbnbNet: "Airbnb zahlt bereits den Nettobetrag aus: Was Sie sehen, kommt bei Ihnen an.",
  apart: "Ohne {amount}, die Sie separat kassieren: Das läuft nicht über {channel}.",
  theChannel: "die OTA",
};
